<script lang="ts" setup>
// Components
import ChartStandard from '../components/charts/standard.vue';
import Filters from '../components/filters/index.vue';
import TableStandard from '../components/tables/standard.vue';
import dayjs from 'dayjs';

// Composables
const { getKeysFromForage } = useStandardStorage();
const { areaId, period, energyType, standardType } = storeToRefs(standardStore());
const { getStandard } = standardRepository();

// Lifecycle
onMounted(async () => {
  await getKeysFromForage();
  if (period.value.start && period.value.end && areaId.value) {
    getStandard({
      energyType: energyType.value,
      start: dayjs(period.value.start).format('YYYY-MM-DD HH:mm'),
      end: dayjs(period.value.end).format('YYYY-MM-DD HH:mm'),
      standardType: standardType.value,
      areaId: areaId.value,
    });
  }
});
</script>
<template>
  <div class="flex flex-col h-screen overflow-hidden bg-amber-400">
    <ui-header :title="$t('standard.standard')" />
    <div class="flex flex-col md:flex-row h-[calc(100vh-48px)] overflow-hidden">
      <filters class="w-full md:w-[320px] flex-shrink-0" />
      <div class="overflow-y-auto flex-1 p-4">
        <ui-card>
          <chart-standard />
        </ui-card>
        <ui-card>
          <table-standard />
        </ui-card>
      </div>
    </div>
  </div>
</template>
